<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputVertical" });
import { t } from "svelte-i18n";
export let code;
</script>

{ $t(`resource.vertical.options.${ code }`) }